<template>
    <div id="stepcontent">
        <div id="title">
            <h2>Dados pessoais</h2>
            <p>Preencha com os dados pessoais</p>
        </div>

        <div id="formblock">

            <div>

                <div class="sectiontitle" style=" margin-top: 1rem;">
                    <hr><h3> Dados 1º proponente</h3><hr>
                </div>


                <div :class="{'badinput': bad(stepdata.proponente_1.name)}" class="input-line">
                    <div class="input-title">
                        <p>Nome Próprio*</p>
                    </div>

                    <div class="input-field">
                        <input v-model="stepdata.proponente_1.name" type="text">
                    </div>

                    <div class="input-icon">
                        <!--
                                            <img src="/static/images/pedido-ch/down-arrow-in-small-circle.svg" alt="">
                        -->
                    </div>
                </div>

                <div :class="{'badinput': bad(stepdata.proponente_1.lastname)}" class="input-line">
                    <div class="input-title">
                        <p>Apelido*</p>
                    </div>

                    <div class="input-field">
                        <input v-model="stepdata.proponente_1.lastname" type="text">
                    </div>

                    <div class="input-icon">
                        <!--
                                            <img src="/static/images/pedido-ch/down-arrow-in-small-circle.svg" alt="">
                        -->
                    </div>
                </div>

                <div :class="{'badinput': bad(stepdata.proponente_1.data_nascimento)}" class="input-line">
                    <div class="input-title">
                        <p>Data de Nascimento*</p>
                    </div>

                    <div class="input-field">
                        <input @blur="stepdata.proponente_1.data_nascimento = fixData(stepdata.proponente_1.data_nascimento)" v-mask="'##/##/####'" v-model="stepdata.proponente_1.data_nascimento" type="text">
                    </div>

                    <div class="input-icon">
                        <!--
                                            <img src="/static/images/pedido-ch/down-arrow-in-small-circle.svg" alt="">
                        -->
                    </div>
                </div>

                <div :class="{'badinput': bad(stepdata.proponente_1.nacionalidade)}" class="input-line">
                    <div class="input-title">
                        <p>Nacionalidade*</p>
                    </div>

                    <div class="input-field">
                        <input v-model="stepdata.proponente_1.nacionalidade" type="text">
                    </div>

                    <div class="input-icon">
                        <!--
                                            <img src="/static/images/pedido-ch/down-arrow-in-small-circle.svg" alt="">
                        -->
                    </div>
                </div>

                <div>
                    <div :class="{'badinput': bad(stepdata.proponente_1.documento)}" class="input-line cursor-pointer" @click="ddopen !== 'documento_proponente_1' ? ddopen = 'documento_proponente_1': ddopen = null">
                        <div class="input-title">
                            <p>Documento de Identificação*</p>
                        </div>

                        <div class="input-field">
                            <p v-html="stepdata.proponente_1.documento" ></p>
                        </div>

                        <div  class="input-icon">
                            <img :class="{'flip': ddopen === 'documento_proponente_1', 'unflip': ddopen !== 'documento_proponente_1'}" src="/static/images/pedido-ch/down-arrow-in-small-circle.svg" alt="">
                        </div>
                    </div>
                    <transition name="slide-fade">
                        <div v-if="ddopen === 'documento_proponente_1'" class="input-expanded">
                            <p v-for="i in documentos" class="expanded-line" @click="stepdata.proponente_1.documento = i; ddopen = null;">{{i}}</p>
                        </div>
                    </transition>
                </div>

                <div :class="{'badinput': bad(stepdata.proponente_1.id_numero)}" class="input-line">
                    <div class="input-title">
                        <p>№ Documento de Identificação*</p>
                    </div>

                    <div class="input-field">
                        <input v-model="stepdata.proponente_1.id_numero" type="text">
                    </div>

                    <div class="input-icon">
                        <!--
                                            <img src="/static/images/pedido-ch/down-arrow-in-small-circle.svg" alt="">
                        -->
                    </div>
                </div>

                <div>
                    <div :class="{'badinput': bad(stepdata.proponente_1.estado_civil)}" class="input-line cursor-pointer" @click="ddopen !== 'estado_civil_proponente_1' ? ddopen = 'estado_civil_proponente_1': ddopen = null">
                        <div class="input-title">
                            <p>Estado Civil*</p>
                        </div>

                        <div class="input-field">
                            <p v-html="stepdata.proponente_1.estado_civil" ></p>
                        </div>

                        <div  class="input-icon">
                            <img :class="{'flip': ddopen === 'estado_civil_proponente_1', 'unflip': ddopen !== 'estado_civil_proponente_1'}" src="/static/images/pedido-ch/down-arrow-in-small-circle.svg" alt="">
                        </div>
                    </div>
                    <transition name="slide-fade">
                        <div v-if="ddopen === 'estado_civil_proponente_1'" class="input-expanded">
                            <p v-for="i in estados_civis" class="expanded-line" @click="stepdata.proponente_1.estado_civil = i; ddopen = null;">{{i}}</p>
                        </div>
                    </transition>
                </div>

                <div :class="{'badinput': bad(stepdata.proponente_1.pais_residencia)}" class="input-line">
                    <div class="input-title">
                        <p>País de residência*</p>
                    </div>

                    <div class="input-field">
                        <input v-model="stepdata.proponente_1.pais_residencia" type="text">
                    </div>

                    <div class="input-icon">
                        <!--
                                            <img src="/static/images/pedido-ch/down-arrow-in-small-circle.svg" alt="">
                        -->
                    </div>
                </div>

                <div :class="{'badinput': bad(stepdata.proponente_1.morada)}" class="input-line">
                    <div class="input-title">
                        <p>Morada Atual*</p>
                    </div>

                    <div class="input-field">
                        <input v-model="stepdata.proponente_1.morada" type="text">
                    </div>

                    <div class="input-icon">
                        <!--
                                            <img src="/static/images/pedido-ch/down-arrow-in-small-circle.svg" alt="">
                        -->
                    </div>
                </div>

                <div :class="{'badinput': bad(stepdata.proponente_1.localidade)}" class="input-line">
                    <div class="input-title">
                        <p>Localidade*</p>
                    </div>

                    <div class="input-field">
                        <input v-model="stepdata.proponente_1.localidade" type="text">
                    </div>

                    <div class="input-icon">
                        <!--
                                            <img src="/static/images/pedido-ch/down-arrow-in-small-circle.svg" alt="">
                        -->
                    </div>
                </div>

                <div>
                    <div :class="{'badinput': bad(stepdata.proponente_1.distrito)}" class="input-line cursor-pointer" @click="ddopen !== 'distrito_proponente_1' ? ddopen = 'distrito_proponente_1': ddopen = null">
                        <div class="input-title">
                            <p>Distrito*</p>
                        </div>

                        <div class="input-field">
                            <p v-html="stepdata.proponente_1.distrito" ></p>
                        </div>

                        <div  class="input-icon">
                            <img :class="{'flip': ddopen === 'distrito_proponente_1', 'unflip': ddopen !== 'distrito_proponente_1'}" src="/static/images/pedido-ch/down-arrow-in-small-circle.svg" alt="">
                        </div>
                    </div>
                    <transition name="slide-fade">
                        <div v-if="ddopen === 'distrito_proponente_1'" class="input-expanded">
                            <p v-for="i in distritos" class="expanded-line" @click="stepdata.proponente_1.distrito = i; ddopen = null;">{{i}}</p>
                        </div>
                    </transition>
                </div>

                <div>
                    <div :class="{'badinput': bad(stepdata.proponente_1.dependente)}" class="input-line cursor-pointer" @click="ddopen !== 'dependente_proponente_1' ? ddopen = 'dependente_proponente_1': ddopen = null">
                        <div class="input-title">
                            <p>№ de Dependentes a Cargo*</p>
                        </div>

                        <div class="input-field">
                            <p v-html="stepdata.proponente_1.dependente" ></p>
                        </div>

                        <div  class="input-icon">
                            <img :class="{'flip': ddopen === 'dependente_proponente_1', 'unflip': ddopen !== 'dependente_proponente_1'}" src="/static/images/pedido-ch/down-arrow-in-small-circle.svg" alt="">
                        </div>
                    </div>
                    <transition name="slide-fade">
                        <div v-if="ddopen === 'dependente_proponente_1'" class="input-expanded">
                            <p v-for="i in dependentes" class="expanded-line" @click="stepdata.proponente_1.dependente = i; ddopen = null;">{{i}}</p>
                        </div>
                    </transition>
                </div>

                <div :class="{'badinput': bad(stepdata.proponente_1.phone1)}" class="input-line" style="margin-top:1.5rem;">
                    <div class="input-title">
                        <p>Telefone 1*</p>
                    </div>

                    <div class="input-field">
                        <input v-mask="'### ### ###'" v-model="stepdata.proponente_1.phone1" type="text">
                    </div>

                    <div class="input-icon">
                        <!--
                                            <img src="/static/images/pedido-ch/down-arrow-in-small-circle.svg" alt="">
                        -->
                    </div>
                </div>

                <div class="input-line" >
                    <div class="input-title">
                        <p>Telefone 2</p>
                    </div>

                    <div class="input-field">
                        <input v-mask="'### ### ###'" v-model="stepdata.proponente_1.phone2" type="text">
                    </div>

                    <div class="input-icon">
                        <!--
                                            <img src="/static/images/pedido-ch/down-arrow-in-small-circle.svg" alt="">
                        -->
                    </div>
                </div>

                <div :class="{'badinput': bad(stepdata.proponente_1.email)}" class="input-line" >
                    <div class="input-title">
                        <p>E-mail*</p>
                    </div>

                    <div class="input-field">
                        <input v-model="stepdata.proponente_1.email" type="text">
                    </div>

                    <div class="input-icon">
                        <!--
                                            <img src="/static/images/pedido-ch/down-arrow-in-small-circle.svg" alt="">
                        -->
                    </div>
                </div>

            </div>

            <div v-if="numProponentes == 2">

                <div class="sectiontitle">
                    <hr><h3> Dados 2º proponente</h3><hr>
                </div>


                <div :class="{'badinput': bad(stepdata.proponente_2.name)}" class="input-line">
                    <div class="input-title">
                        <p>Nome Próprio*</p>
                    </div>

                    <div class="input-field">
                        <input v-model="stepdata.proponente_2.name" type="text">
                    </div>

                    <div class="input-icon">
                        <!--
                                            <img src="/static/images/pedido-ch/down-arrow-in-small-circle.svg" alt="">
                        -->
                    </div>
                </div>

                <div :class="{'badinput': bad(stepdata.proponente_2.lastname)}" class="input-line">
                    <div class="input-title">
                        <p>Apelido*</p>
                    </div>

                    <div class="input-field">
                        <input v-model="stepdata.proponente_2.lastname" type="text">
                    </div>

                    <div class="input-icon">
                        <!--
                                            <img src="/static/images/pedido-ch/down-arrow-in-small-circle.svg" alt="">
                        -->
                    </div>
                </div>

                <div :class="{'badinput': bad(stepdata.proponente_2.data_nascimento)}"  class="input-line">
                    <div class="input-title">
                        <p>Data de Nascimento*</p>
                    </div>

                    <div class="input-field">
                        <input v-mask="'##/##/####'" @blur="stepdata.proponente_2.data_nascimento = fixData(stepdata.proponente_2.data_nascimento)" v-model="stepdata.proponente_2.data_nascimento" type="text">
                    </div>

                    <div class="input-icon">
                        <!--
                                            <img src="/static/images/pedido-ch/down-arrow-in-small-circle.svg" alt="">
                        -->
                    </div>
                </div>

                <div :class="{'badinput': bad(stepdata.proponente_2.nacionalidade)}" class="input-line">
                    <div class="input-title">
                        <p>Nacionalidade*</p>
                    </div>

                    <div class="input-field">
                        <input v-model="stepdata.proponente_2.nacionalidade" type="text">
                    </div>

                    <div class="input-icon">
                        <!--
                                            <img src="/static/images/pedido-ch/down-arrow-in-small-circle.svg" alt="">
                        -->
                    </div>
                </div>

                <div>
                    <div :class="{'badinput': bad(stepdata.proponente_2.documento)}"  class="input-line cursor-pointer" @click="ddopen !== 'documento_proponente_2' ? ddopen = 'documento_proponente_2': ddopen = null">
                        <div class="input-title">
                            <p>Documento de Identificação*</p>
                        </div>

                        <div class="input-field">
                            <p v-html="stepdata.proponente_2.documento" ></p>
                        </div>

                        <div  class="input-icon">
                            <img :class="{'flip': ddopen === 'documento_proponente_2', 'unflip': ddopen !== 'documento_proponente_2'}" src="/static/images/pedido-ch/down-arrow-in-small-circle.svg" alt="">
                        </div>
                    </div>
                    <transition name="slide-fade">
                        <div v-if="ddopen === 'documento_proponente_2'" class="input-expanded">
                            <p v-for="i in documentos" class="expanded-line" @click="stepdata.proponente_2.documento = i; ddopen = null;">{{i}}</p>
                        </div>
                    </transition>
                </div>

                <div :class="{'badinput': bad(stepdata.proponente_2.id_numero)}" class="input-line">
                    <div class="input-title">
                        <p>№ Documento de Identificação*</p>
                    </div>

                    <div class="input-field">
                        <input v-model="stepdata.proponente_2.id_numero" type="text">
                    </div>

                    <div class="input-icon">
                        <!--
                                            <img src="/static/images/pedido-ch/down-arrow-in-small-circle.svg" alt="">
                        -->
                    </div>
                </div>

                <div>
                    <div :class="{'badinput': bad(stepdata.proponente_2.estado_civil)}"  class="input-line cursor-pointer" @click="ddopen !== 'estado_civil_proponente_2' ? ddopen = 'estado_civil_proponente_2': ddopen = null">
                        <div class="input-title">
                            <p>Estado Civil*</p>
                        </div>

                        <div class="input-field">
                            <p v-html="stepdata.proponente_2.estado_civil" ></p>
                        </div>

                        <div  class="input-icon">
                            <img :class="{'flip': ddopen === 'estado_civil_proponente_2', 'unflip': ddopen !== 'estado_civil_proponente_2'}" src="/static/images/pedido-ch/down-arrow-in-small-circle.svg" alt="">
                        </div>
                    </div>
                    <transition name="slide-fade">
                        <div v-if="ddopen === 'estado_civil_proponente_2'" class="input-expanded">
                            <p v-for="i in estados_civis" class="expanded-line" @click="stepdata.proponente_2.estado_civil = i; ddopen = null;">{{i}}</p>
                        </div>
                    </transition>
                </div>

                <div :class="{'badinput': bad(stepdata.proponente_2.pais_residencia)}"  class="input-line">
                    <div class="input-title">
                        <p>País de residência*</p>
                    </div>

                    <div class="input-field">
                        <input v-model="stepdata.proponente_2.pais_residencia" type="text">
                    </div>

                    <div class="input-icon">
                        <!--
                                            <img src="/static/images/pedido-ch/down-arrow-in-small-circle.svg" alt="">
                        -->
                    </div>
                </div>

                <div :class="{'badinput': bad(stepdata.proponente_2.morada)}" class="input-line">
                    <div class="input-title">
                        <p>Morada Atual*</p>
                    </div>

                    <div class="input-field">
                        <input v-model="stepdata.proponente_2.morada" type="text">
                    </div>

                    <div class="input-icon">
                        <!--
                                            <img src="/static/images/pedido-ch/down-arrow-in-small-circle.svg" alt="">
                        -->
                    </div>
                </div>

                <div :class="{'badinput': bad(stepdata.proponente_2.localidade)}" class="input-line">
                    <div class="input-title">
                        <p>Localidade*</p>
                    </div>

                    <div class="input-field">
                        <input v-model="stepdata.proponente_2.localidade" type="text">
                    </div>

                    <div class="input-icon">
                        <!--
                                            <img src="/static/images/pedido-ch/down-arrow-in-small-circle.svg" alt="">
                        -->
                    </div>
                </div>

                <div>
                    <div :class="{'badinput': bad(stepdata.proponente_2.distrito)}"  class="input-line cursor-pointer"  @click="ddopen !== 'distrito_proponente_2' ? ddopen = 'distrito_proponente_2': ddopen = null">
                        <div class="input-title">
                            <p>Distrito*</p>
                        </div>

                        <div class="input-field">
                            <p v-html="stepdata.proponente_2.distrito" ></p>
                        </div>

                        <div class="input-icon">
                            <img :class="{'flip': ddopen === 'distrito_proponente_2', 'unflip': ddopen !== 'distrito_proponente_2'}" src="/static/images/pedido-ch/down-arrow-in-small-circle.svg" alt="">
                        </div>
                    </div>
                    <transition name="slide-fade">
                        <div v-if="ddopen === 'distrito_proponente_2'" class="input-expanded">
                            <p v-for="i in distritos" class="expanded-line" @click="stepdata.proponente_2.distrito = i; ddopen = null;">{{i}}</p>
                        </div>
                    </transition>
                </div>

                <div>
                    <div :class="{'badinput': bad(stepdata.proponente_2.dependente)}" class="input-line cursor-pointer" @click="ddopen !== 'dependente_proponente_2' ? ddopen = 'dependente_proponente_2': ddopen = null">
                        <div class="input-title">
                            <p>№ de Dependentes a Cargo*</p>
                        </div>

                        <div class="input-field">
                            <p v-html="stepdata.proponente_2.dependente" ></p>
                        </div>

                        <div  class="input-icon">
                            <img :class="{'flip': ddopen === 'dependente_proponente_2', 'unflip': ddopen !== 'dependente_proponente_2'}" src="/static/images/pedido-ch/down-arrow-in-small-circle.svg" alt="">
                        </div>
                    </div>
                    <transition name="slide-fade">
                        <div v-if="ddopen === 'dependente_proponente_2'" class="input-expanded">
                            <p v-for="i in dependentes" class="expanded-line" @click="stepdata.proponente_2.dependente = i; ddopen = null;">{{i}}</p>
                        </div>
                    </transition>
                </div>

                <div :class="{'badinput': bad(stepdata.proponente_2.phone1)}" class="input-line" style="margin-top:1.5rem;">
                    <div class="input-title">
                        <p>Telefone 1*</p>
                    </div>

                    <div class="input-field">
                        <input v-mask="'### ### ###'" v-model="stepdata.proponente_2.phone1" type="text">
                    </div>

                    <div class="input-icon">
                        <!--
                                            <img src="/static/images/pedido-ch/down-arrow-in-small-circle.svg" alt="">
                        -->
                    </div>
                </div>

                <div class="input-line" >
                    <div class="input-title">
                        <p>Telefone 2</p>
                    </div>

                    <div class="input-field">
                        <input v-mask="'### ### ###'" v-model="stepdata.proponente_2.phone2" type="text">
                    </div>

                    <div class="input-icon">
                        <!--
                                            <img src="/static/images/pedido-ch/down-arrow-in-small-circle.svg" alt="">
                        -->
                    </div>
                </div>

                <div class="input-line" :class="{'badinput': bad(stepdata.proponente_2.email)}" >
                    <div class="input-title">
                        <p>E-mail*</p>
                    </div>

                    <div class="input-field">
                        <input v-model="stepdata.proponente_2.email" type="text">
                    </div>

                    <div class="input-icon">
                        <!--
                                            <img src="/static/images/pedido-ch/down-arrow-in-small-circle.svg" alt="">
                        -->
                    </div>
                </div>


            </div>

            <div v-if="numFiadores >= 1">

                <div class="sectiontitle">
                    <hr><h3> Dados 1º fiador</h3><hr>
                </div>

                <div>
                    <div :class="{'badinput': bad(stepdata.fiador_1.relacao_proponentes)}" class="input-line cursor-pointer" @click="ddopen !== 'relacao_proponentes_fiador_1' ? ddopen = 'relacao_proponentes_fiador_1' : ddopen = null">
                        <div class="input-title">
                            <p>Relação com os Proponentes*</p>
                        </div>

                        <div class="input-field">
                            <p v-html="stepdata.fiador_1.relacao_proponentes" ></p>
                        </div>

                        <div  class="input-icon">
                            <img :class="{'flip': ddopen === 'relacao_proponentes_fiador_1', 'unflip': ddopen !== 'relacao_proponentes_fiador_1'}" src="/static/images/pedido-ch/down-arrow-in-small-circle.svg" alt="">
                        </div>
                    </div>
                    <transition name="slide-fade">
                        <div v-if="ddopen === 'relacao_proponentes_fiador_1'" class="input-expanded">
                            <p v-for="j in relacoes_proponente" class="expanded-line" @click="stepdata.fiador_1.relacao_proponentes = j; ddopen = null;">{{j}}</p>
                        </div>
                    </transition>
                </div>

                <div class="input-line">
                    <div :class="{'badinput': bad(stepdata.fiador_1.name)}" class="input-title">
                        <p>Nome Próprio*</p>
                    </div>

                    <div class="input-field">
                        <input v-model="stepdata.fiador_1.name" type="text">
                    </div>

                    <div class="input-icon">
                        <!--
                                            <img src="/static/images/pedido-ch/down-arrow-in-small-circle.svg" alt="">
                        -->
                    </div>
                </div>

                <div class="input-line">
                    <div :class="{'badinput': bad(stepdata.fiador_1.lastname)}" class="input-title">
                        <p>Apelido*</p>
                    </div>

                    <div class="input-field">
                        <input v-model="stepdata.fiador_1.lastname" type="text">
                    </div>

                    <div class="input-icon">
                        <!--
                                            <img src="/static/images/pedido-ch/down-arrow-in-small-circle.svg" alt="">
                        -->
                    </div>
                </div>

                <div :class="{'badinput': bad(stepdata.fiador_1.data_nascimento)}" class="input-line">
                    <div class="input-title">
                        <p>Data de Nascimento*</p>
                    </div>

                    <div class="input-field">
                        <input v-mask="'##/##/####'" @blur="stepdata.fiador_1.data_nascimento = fixData(stepdata.fiador_1.data_nascimento)" v-model="stepdata.fiador_1.data_nascimento" type="text">
                    </div>

                    <div class="input-icon">
                        <!--
                                            <img src="/static/images/pedido-ch/down-arrow-in-small-circle.svg" alt="">
                        -->
                    </div>
                </div>

                <div>
                    <div :class="{'badinput': bad(stepdata.fiador_1.documento)}" class="input-line cursor-pointer" @click="ddopen !== 'documento_fiador_1' ? ddopen = 'documento_fiador_1' : ddopen = null">
                        <div class="input-title">
                            <p>Documento de Identificação*</p>
                        </div>

                        <div class="input-field">
                            <p v-html="stepdata.fiador_1.documento" ></p>
                        </div>

                        <div  class="input-icon">
                            <img :class="{'flip': ddopen === 'documento_fiador_1', 'unflip': ddopen !== 'documento_fiador_1'}" src="/static/images/pedido-ch/down-arrow-in-small-circle.svg" alt="">
                        </div>
                    </div>
                    <transition name="slide-fade">
                        <div v-if="ddopen === 'documento_fiador_1'" class="input-expanded">
                            <p v-for="j in documentos" class="expanded-line" @click="stepdata.fiador_1.documento = j; ddopen = null;">{{j}}</p>
                        </div>
                    </transition>
                </div>

                <div :class="{'badinput': bad(stepdata.fiador_1.id_numero)}" class="input-line">
                    <div class="input-title">
                        <p>№ Documento de Identificação*</p>
                    </div>

                    <div class="input-field">
                        <input v-model="stepdata.fiador_1.id_numero" type="text">
                    </div>

                    <div class="input-icon">
                        <!--
                                            <img src="/static/images/pedido-ch/down-arrow-in-small-circle.svg" alt="">
                        -->
                    </div>
                </div>

                <div>
                    <div :class="{'badinput': bad(stepdata.fiador_1.estado_civil)}" class="input-line cursor-pointer" @click="ddopen !== 'estado_civil_fiador_1' ? ddopen = 'estado_civil_fiador_1' : ddopen = null">
                        <div class="input-title">
                            <p>Estado Civil*</p>
                        </div>

                        <div class="input-field">
                            <p v-html="stepdata.fiador_1.estado_civil" ></p>
                        </div>

                        <div  class="input-icon">
                            <img :class="{'flip': ddopen === 'estado_civil_fiador_1', 'unflip': ddopen !== 'estado_civil_fiador_1'}" src="/static/images/pedido-ch/down-arrow-in-small-circle.svg" alt="">
                        </div>
                    </div>
                    <transition name="slide-fade">
                        <div v-if="ddopen === 'estado_civil_fiador_1'" class="input-expanded">
                            <p v-for="j in estados_civis" class="expanded-line" @click="stepdata.fiador_1.estado_civil = j; ddopen = null;">{{j}}</p>
                        </div>
                    </transition>
                </div>

                <div>
                    <div :class="{'badinput': bad(stepdata.fiador_1.tipo_habitacao)}" class="input-line cursor-pointer"  @click="ddopen !== 'tipo_habitacao_fiador_1' ? ddopen = 'tipo_habitacao_fiador_1' : ddopen = null">
                        <div class="input-title">
                            <p>Tipo de Habitação Atual*</p>
                        </div>

                        <div class="input-field">
                            <p v-html="stepdata.fiador_1.tipo_habitacao" ></p>
                        </div>

                        <div class="input-icon">
                            <img :class="{'flip': ddopen === 'tipo_habitacao_fiador_1', 'unflip': ddopen !== 'tipo_habitacao_fiador_1'}" src="/static/images/pedido-ch/down-arrow-in-small-circle.svg" alt="">
                        </div>
                    </div>
                    <transition name="slide-fade">
                        <div v-if="ddopen === 'tipo_habitacao_fiador_1'" class="input-expanded">
                            <p v-for="j in tipos_habitacao" class="expanded-line" @click="stepdata.fiador_1.tipo_habitacao = j; ddopen = null;">{{j}}</p>
                        </div>
                    </transition>
                </div>

                <div :class="{'badinput': bad(stepdata.fiador_1.encargo_mensal)}" class="input-line">
                    <div class="input-title">
                        <p>Encargo mensal com a habitação*</p>
                    </div>

                    <div class="input-field">
                        <money v-model="stepdata.fiador_1.encargo_mensal" v-bind="money"></money>
                    </div>

                    <div class="input-icon">
                        €
                    </div>
                </div>

                <div>
                    <div :class="{'badinput': bad(stepdata.fiador_1.dependente)}" class="input-line cursor-pointer" @click="ddopen !== 'dependente_fiador_1' ? ddopen = 'dependente_fiador_1' : ddopen = null">
                        <div class="input-title">
                            <p>№ de Dependentes a Cargo*</p>
                        </div>

                        <div class="input-field">
                            <p v-html="stepdata.fiador_1.dependente" ></p>
                        </div>

                        <div  class="input-icon">
                            <img :class="{'flip': ddopen === 'dependente_fiador_1', 'unflip': ddopen !== 'dependente_fiador_1'}" src="/static/images/pedido-ch/down-arrow-in-small-circle.svg" alt="">
                        </div>
                    </div>
                    <transition name="slide-fade">
                        <div v-if="ddopen === 'dependente_fiador_1'" class="input-expanded">
                            <p v-for="j in dependentes" class="expanded-line" @click="stepdata.fiador_1.dependente = j; ddopen = null;">{{j}}</p>
                        </div>
                    </transition>
                </div>

            </div>

            <div v-if="numFiadores == 2">

                <div style="" class="sectiontitle">
                    <hr><h3> Dados 2º fiador</h3><hr>
                </div>

                <div>
                    <div :class="{'badinput': bad(stepdata.fiador_2.relacao_proponentes)}" class="input-line cursor-pointer" @click="ddopen !== 'relacao_proponentes_fiador_2' ? ddopen = 'relacao_proponentes_fiador_2' : ddopen = null">
                        <div class="input-title">
                            <p>Relação com os Proponentes*</p>
                        </div>

                        <div class="input-field">
                            <p v-html="stepdata.fiador_2.relacao_proponentes" ></p>
                        </div>

                        <div  class="input-icon">
                            <img :class="{'flip': ddopen === 'relacao_proponentes_fiador_2', 'unflip': ddopen !== 'relacao_proponentes_fiador_2'}" src="/static/images/pedido-ch/down-arrow-in-small-circle.svg" alt="">
                        </div>
                    </div>
                    <transition name="slide-fade">
                        <div v-if="ddopen === 'relacao_proponentes_fiador_2'" class="input-expanded">
                            <p v-for="j in relacoes_proponente" class="expanded-line" @click="stepdata.fiador_2.relacao_proponentes = j; ddopen = null;">{{j}}</p>
                        </div>
                    </transition>
                </div>

                <div :class="{'badinput': bad(stepdata.fiador_2.name)}" class="input-line">
                    <div class="input-title">
                        <p>Nome Próprio*</p>
                    </div>

                    <div class="input-field">
                        <input v-model="stepdata.fiador_2.name" type="text">
                    </div>

                    <div class="input-icon">
                        <!--
                                            <img src="/static/images/pedido-ch/down-arrow-in-small-circle.svg" alt="">
                        -->
                    </div>
                </div>

                <div :class="{'badinput': bad(stepdata.fiador_2.lastname)}" class="input-line">
                    <div class="input-title">
                        <p>Apelido*</p>
                    </div>

                    <div class="input-field">
                        <input v-model="stepdata.fiador_2.lastname" type="text">
                    </div>

                    <div class="input-icon">
                        <!--
                                            <img src="/static/images/pedido-ch/down-arrow-in-small-circle.svg" alt="">
                        -->
                    </div>
                </div>

                <div :class="{'badinput': bad(stepdata.fiador_2.data_nascimento)}" class="input-line">
                    <div class="input-title">
                        <p>Data de Nascimento*</p>
                    </div>

                    <div class="input-field">
                        <input v-mask="'##/##/####'" @blur="stepdata.fiador_2.data_nascimento = fixData(stepdata.fiador_2.data_nascimento)" v-model="stepdata.fiador_2.data_nascimento" type="text">
                    </div>

                    <div class="input-icon">
                        <!--
                                            <img src="/static/images/pedido-ch/down-arrow-in-small-circle.svg" alt="">
                        -->
                    </div>
                </div>

                <div>
                    <div :class="{'badinput': bad(stepdata.fiador_2.documento_identificacao)}" class="input-line cursor-pointer" @click="ddopen !== 'documento_identificacao_fiador_2' ? ddopen = 'documento_identificacao_fiador_2' : ddopen = null">
                        <div class="input-title">
                            <p>Documento de Identificação*</p>
                        </div>

                        <div class="input-field">
                            <p v-html="stepdata.fiador_2.documento_identificacao" ></p>
                        </div>

                        <div  class="input-icon">
                            <img :class="{'flip': ddopen === 'documento_identificacao_fiador_2', 'unflip': ddopen !== 'documento_identificacao_fiador_2'}" src="/static/images/pedido-ch/down-arrow-in-small-circle.svg" alt="">
                        </div>
                    </div>
                    <transition name="slide-fade">
                        <div v-if="ddopen === 'documento_identificacao_fiador_2'" class="input-expanded">
                            <p v-for="j in documentos" class="expanded-line" @click="stepdata.fiador_2.documento_identificacao = j; ddopen = null;">{{j}}</p>
                        </div>
                    </transition>
                </div>

                <div :class="{'badinput': bad(stepdata.fiador_2.id_numero)}" class="input-line">
                    <div class="input-title">
                        <p>№ Documento de Identificação*</p>
                    </div>

                    <div class="input-field">
                        <input v-model="stepdata.fiador_2.id_numero" type="text">
                    </div>

                    <div class="input-icon">
                        <!--
                                            <img src="/static/images/pedido-ch/down-arrow-in-small-circle.svg" alt="">
                        -->
                    </div>
                </div>

                <div>
                    <div :class="{'badinput': bad(stepdata.fiador_2.estado_civil)}" class="input-line cursor-pointer" @click="ddopen !== 'estado_civil_fiador_2' ? ddopen = 'estado_civil_fiador_2' : ddopen = null">
                        <div class="input-title">
                            <p>Estado Civil*</p>
                        </div>

                        <div class="input-field">
                            <p v-html="stepdata.fiador_2.estado_civil" ></p>
                        </div>

                        <div  class="input-icon">
                            <img :class="{'flip': ddopen === 'estado_civil_fiador_2', 'unflip': ddopen !== 'estado_civil_fiador_2'}" src="/static/images/pedido-ch/down-arrow-in-small-circle.svg" alt="">
                        </div>
                    </div>
                    <transition name="slide-fade">
                        <div v-if="ddopen === 'estado_civil_fiador_2'" class="input-expanded">
                            <p v-for="j in estados_civis" class="expanded-line" @click="stepdata.fiador_2.estado_civil = j; ddopen = null;">{{j}}</p>
                        </div>
                    </transition>
                </div>

                <div>
                    <div :class="{'badinput': bad(stepdata.fiador_2.tipo_habitacao)}"  class="input-line cursor-pointer" @click="ddopen !== 'tipo_habitacao_fiador_2' ? ddopen = 'tipo_habitacao_fiador_2' : ddopen = null">
                        <div class="input-title">
                            <p>Tipo de Habitação Atual*</p>
                        </div>

                        <div class="input-field">
                            <p v-html="stepdata.fiador_2.tipo_habitacao" ></p>
                        </div>

                        <div  class="input-icon">
                            <img :class="{'flip': ddopen === 'tipo_habitacao_fiador_2', 'unflip': ddopen !== 'tipo_habitacao_fiador_2'}" src="/static/images/pedido-ch/down-arrow-in-small-circle.svg" alt="">
                        </div>
                    </div>
                    <transition name="slide-fade">
                        <div v-if="ddopen === 'tipo_habitacao_fiador_2'" class="input-expanded">
                            <p v-for="j in tipos_habitacao" class="expanded-line" @click="stepdata.fiador_2.tipo_habitacao = j; ddopen = null;">{{j}}</p>
                        </div>
                    </transition>
                </div>

                <div :class="{'badinput': bad(stepdata.fiador_2.encargo_mensal)}"  class="input-line">
                    <div class="input-title">
                        <p>Encargo mensal com a habitação*</p>
                    </div>

                    <div class="input-field">
                        <money v-model="stepdata.fiador_2.encargo_mensal" v-bind="money"></money>
                    </div>

                    <div class="input-icon">
                        €
                    </div>
                </div>

                <div>
                    <div :class="{'badinput': bad(stepdata.fiador_2.dependente)}" class="input-line cursor-pointer" @click="ddopen !== 'dependente_fiador_2' ? ddopen = 'dependente_fiador_2' : ddopen = null">
                        <div class="input-title">
                            <p>№ de Dependentes a Cargo*</p>
                        </div>

                        <div class="input-field">
                            <p v-html="stepdata.fiador_2.dependente" ></p>
                        </div>

                        <div  class="input-icon">
                            <img :class="{'flip': ddopen === 'dependente_fiador_2', 'unflip': ddopen !== 'dependente_fiador_2'}" src="/static/images/pedido-ch/down-arrow-in-small-circle.svg" alt="">
                        </div>
                    </div>
                    <transition name="slide-fade">
                        <div v-if="ddopen === 'dependente_fiador_2'" class="input-expanded">
                            <p v-for="j in dependentes" class="expanded-line" @click="stepdata.fiador_2.dependente = j; ddopen = null;">{{j}}</p>
                        </div>
                    </transition>
                </div>

            </div>

        </div>

    </div>

</template>
<script>
import { Money } from "v-money";
import { mask } from "vue-the-mask";
export default {
  components: {
    Money
  },

  directives: {
    mask
  },

  props: ["stepdata", "steps", "submitted"],

  data() {
    return {
      numFiadores: 0,
      numProponentes: 1,

      tipos: ["Apartamento", "Vivenda", "Moradia Geminada"],
      destinos: ["Habitação Própria Permanente", "Habitação Secundária"],
      estados_civis: [
        "Solteiro",
        "Casado",
        "União de Facto",
        "Separado de Facto",
        "Divorciado",
        "Viúvo"
      ],
      documentos: [
        "Bilhete de Identidade",
        "Cartão de Cidadão",
        "Autorização de Residência",
        "Passaporte"
      ],
      tipos_habitacao: ["Arrendamento", "Familiares", "Propriedade", "Outro"],
      distritos: [
        "Aveiro",
        "Beja",
        "Braga",
        "Bragança",
        "Castelo Branco",
        "Coimbra",
        "Évora",
        "Faro",
        "Guarda",
        "Ilha da Madeira",
        "Ilha de Porto Santo",
        "Leiria",
        "Lisboa",
        "Portalegre",
        "Porto",
        "Santarém",
        "Setúbal",
        "Viana do Castelo",
        "Vila Real",
        "Viseu",
        "Outro"
      ],
      ddopen: null,
      relacoes_proponente: [
        "Pais",
        "Filho",
        "Irmão/Irmã",
        "Outro familiar",
        "Amigo",
        "Outro"
      ],
      dependentes: ["0", "1", "2", "3", "4", "5", "6"],
      money: {
        decimal: ",",
        thousands: ".",
        prefix: "",
        suffix: "",
        precision: 2,
        masked: false
      }
    };
  },

  created() {
    this.numFiadores = parseInt(this.steps[1].fiador) || 0;
    this.numProponentes = this.steps[1].proponente;
  },

  computed: {
    missingField() {
      let p1 =
        !this.stepdata.proponente_1.name ||
        !this.stepdata.proponente_1.lastname ||
        !this.stepdata.proponente_1.data_nascimento ||
        !this.stepdata.proponente_1.nacionalidade ||
        !this.stepdata.proponente_1.documento ||
        !this.stepdata.proponente_1.id_numero ||
        !this.stepdata.proponente_1.estado_civil ||
        !this.stepdata.proponente_1.pais_residencia ||
        !this.stepdata.proponente_1.morada ||
        !this.stepdata.proponente_1.localidade ||
        !this.stepdata.proponente_1.distrito ||
        !this.stepdata.proponente_1.dependente ||
        !this.stepdata.proponente_1.phone1 ||
        !this.stepdata.proponente_1.email;

      let p2 =
        this.numProponentes === 2 &&
        (!this.stepdata.proponente_2.name ||
          !this.stepdata.proponente_2.lastname ||
          !this.stepdata.proponente_2.data_nascimento ||
          !this.stepdata.proponente_2.nacionalidade ||
          !this.stepdata.proponente_2.documento ||
          !this.stepdata.proponente_2.id_numero ||
          !this.stepdata.proponente_2.estado_civil ||
          !this.stepdata.proponente_2.pais_residencia ||
          !this.stepdata.proponente_2.morada ||
          !this.stepdata.proponente_2.localidade ||
          !this.stepdata.proponente_2.distrito ||
          !this.stepdata.proponente_2.dependente ||
          !this.stepdata.proponente_2.phone1 ||
          !this.stepdata.proponente_2.email);

      let f1 =
        this.numFiadores >= 1 &&
        (!this.stepdata.fiador_1.relacao_proponentes ||
          !this.stepdata.fiador_1.name ||
          !this.stepdata.fiador_1.lastname ||
          !this.stepdata.fiador_1.data_nascimento ||
          !this.stepdata.fiador_1.documento ||
          !this.stepdata.fiador_1.id_numero ||
          !this.stepdata.fiador_1.estado_civil ||
          !this.stepdata.fiador_1.tipo_habitacao ||
          !this.stepdata.fiador_1.encargo_mensal ||
          !this.stepdata.fiador_1.dependente);

      let f2 =
        this.numFiadores === 2 &&
        (!this.stepdata.fiador_2.relacao_proponentes ||
          !this.stepdata.fiador_2.name ||
          !this.stepdata.fiador_2.lastname ||
          !this.stepdata.fiador_2.data_nascimento ||
          !this.stepdata.fiador_2.documento ||
          !this.stepdata.fiador_2.id_numero ||
          !this.stepdata.fiador_2.estado_civil ||
          !this.stepdata.fiador_2.tipo_habitacao ||
          !this.stepdata.fiador_2.encargo_mensal ||
          !this.stepdata.fiador_2.dependente);

      console.log(
        "p1",
        !this.stepdata.proponente_1.name,
        !this.stepdata.proponente_1.lastname,
        !this.stepdata.proponente_1.data_nascimento,
        !this.stepdata.proponente_1.nacionalidade,
        !this.stepdata.proponente_1.documento,
        !this.stepdata.proponente_1.id_numero,
        !this.stepdata.proponente_1.estado_civil,
        !this.stepdata.proponente_1.pais_residencia,
        !this.stepdata.proponente_1.morada,
        !this.stepdata.proponente_1.localidade,
        !this.stepdata.proponente_1.distrito,
        !this.stepdata.proponente_1.dependente,
        !this.stepdata.proponente_1.phone1,
        !this.stepdata.proponente_1.email
      );
      console.log(
        "f1",
        !this.stepdata.fiador_1.relacao_proponentes,
        !this.stepdata.fiador_1.name,
        !this.stepdata.fiador_1.lastname,
        !this.stepdata.fiador_1.data_nascimento,
        !this.stepdata.fiador_1.documento,
        !this.stepdata.fiador_1.id_numero,
        !this.stepdata.fiador_1.estado_civil,
        !this.stepdata.fiador_1.tipo_habitacao,
        !this.stepdata.fiador_1.encargo_mensal,
        !this.stepdata.fiador_1.dependente
      );
      console.log("conditions", p1, p2, f1, f2);

      return p1 || p2 || f1 || f2;
    }
  },

  methods: {
    bad(val) {
      return this.submitted && !val;
    },

    fixData(val) {
      let a = val.split("/");
      let e = a[1] + "/" + a[0] + "/" + a[2];
      if ([4, 6, 9, 11].indexOf(parseInt(a[1])) !== -1) {
        if (parseInt(a[0]) > 30) {
          return "00/00/0000";
        }
      }
      if (parseInt(a[1]) === 2) {
        if (
          parseInt(a[2]) % 400 === 0 ||
          (parseInt(a[2]) % 4 === 0 && parseInt(a[2]) % 100 !== 0)
        ) {
          if (parseInt(a[0]) > 29) {
            return "00/00/0000";
          }
        } else {
          if (parseInt(a[0]) > 28) {
            return "00/00/0000";
          }
        }
      }
      let p = Date.parse(e);
      if (isNaN(p) === false) {
        return val;
      }
      return "00/00/0000";
    }
  }
};
</script>
<style lang="scss" scoped>
.badinput {
  border: solid 1px #e90054 !important;
}

.sectiontitle {
  display: flex;
  justify-content: center;
  margin-left: 0.75rem;
  margin-right: -0.75rem;
  margin-top: 5rem;
}

#stepcontent {
  position: relative;
  text-align: center;
}
#title {
  padding: 2rem 0;
}
#title h2 {
  color: #2d3256;
  font-weight: 900;
  font-size: 2.5rem;
}
#title p {
  color: #4f4f4f;
  font-weight: 400;
  font-size: 1.25rem;
}

$input-width: 45rem;

#formblock {
  max-width: $input-width;
  margin: auto;
  margin-bottom: 2rem;
}

#formblock h3 {
  font-size: 2rem;
  white-space: nowrap;
  margin: 0 0.5rem;
}

hr {
  height: 2px;
  width: 100%;
  color: #4a4a4a;
  background: #4a4a4a;
}

$font-size: 1.125rem;
$input-line-height: 3rem;
.input-line {
  border: solid 1px #f5f5f5;
  position: relative;
  background-color: #ffffff;
  width: 100%;
  height: $input-line-height;
  display: flex;
  margin: 0.75rem;
}

.input-expanded {
  position: absolute;
  background-color: #ffffff;
  width: 100%;
  margin: -0.75rem 0.75rem 0.75rem;
  color: black;
  padding: 0.5rem 1rem 0;
  max-width: $input-width;
  z-index: 4;
  max-height: $input-line-height * 0.8 * 5;
  overflow-y: auto;
}

.expanded-line {
  position: relative;
  height: $input-line-height * 0.8;
  line-height: $input-line-height * 0.8;
  font-size: $font-size * 0.8;
  display: flex;
  padding-left: 0.75rem;
  border-bottom: solid 1px #f1f1f1;
  cursor: pointer;
}

.expanded-line:hover {
  color: white !important;
  background-color: #e90054 !important;
}

.expanded-line:last-child {
  border-bottom: none;
}

.input-title {
  line-height: $input-line-height;
  padding: 0 0 0 1.25rem;
  color: black;
  font-size: $font-size;
  flex-grow: 1;
  white-space: nowrap;
}

.input-line p {
  text-align: left;
}

.input-title {
  line-height: $input-line-height;
  padding: 0 1.25rem;
  color: black;
  font-size: $font-size;
  flex-grow: 1;
  white-space: nowrap;
}

.input-field {
  //line-height:$input-line-height;
  padding: 0.675rem 1rem;
  color: black;
  font-size: $font-size;
  flex-grow: 10;
}

.input-field input {
  //line-height:$input-line-height;
  text-align: right;
  color: #4a4a4a;
  cursor: text;
  width: 100%;
  font-weight: 600;
  outline: none !important;
}

.input-field p {
  //line-height:$input-line-height;
  text-align: right;
  color: #4a4a4a;
  cursor: pointer;
  width: 100%;
  font-weight: 600;
  outline: none !important;
}

.input-icon {
  line-height: 1rem;
  padding: 1rem 0.5rem;
  color: black;
  width: 2rem;
  min-width: 22px;
}

.input-icon img {
  cursor: pointer;
}

.flip {
  -webkit-transition: all 0.5s ease;
  -moz-transition: all 0.5s ease;
  -o-transition: all 0.5s ease;
  transition: all 0.5s ease;
  transform: rotate(180deg);
}

.unflip {
  -webkit-transition: all 0.5s ease;
  -moz-transition: all 0.5s ease;
  -o-transition: all 0.5s ease;
  transition: all 0.5s ease;
  transform: rotate(0deg);
}
</style>



// WEBPACK FOOTER //
// src/pages/CreditoHabitacao/Step2.vue